import React from 'react';
import PropTyes from 'prop-types';
import styled from 'styled-components';
import { Box, Text } from '../common';

const RemoveContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  margin-bottom: 16px;
  height: 48px;
`;

function DropContainer(props) {
  const { title, ...restProps } = props;
  return (
    <RemoveContainer
      bg="secondary"
      className="drag-remove-container"
      {...restProps}
    >
      <Text>{title}</Text>
    </RemoveContainer>
  );
}

DropContainer.propTypes = {
  title: PropTyes.string
};

export default DropContainer;
